import React, { memo } from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, ButtonTypeTokens, } from '@voltmoney/schema';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Button from '../button/Button';
import { View } from 'react-native';
import Stack from '../stack/Stack';
/**
 * Primary UI component for user interaction
 */
const Repayment = ({ id, title, message, amount, btnText, onPress, triggerAction, warning, action, }) => {
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, { style: {
            padding: 16,
            flex: 1,
            //borderColor: ColorTokens.Primary_10,
            backgroundColor: ColorTokens.White,
            //borderWidth: 1
        } },
        React.createElement(Typography, { label: title, lineHeight: 24, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night }),
        React.createElement(Space, { size: SizeTypeTokens.XL }),
        React.createElement(View, { style: {
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
            } },
            React.createElement(View, { style: { flex: 1, flexDirection: 'column' } },
                React.createElement(Typography, { label: message, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, lineHeight: 18, fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night }),
                    React.createElement(Space, { size: SizeTypeTokens.XS }),
                    React.createElement(Typography, { id: id, label: amount, lineHeight: 28, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.XL, color: ColorTokens.Grey_Night }))),
            React.createElement(View, { nativeID: 'bt_dashboard_flexiPay', style: { alignItems: 'flex-end' } },
                React.createElement(Button, { type: ButtonTypeTokens.MediumOutline, onPress: handleAction, labelColor: ColorTokens.Primary_100, label: btnText }))),
        warning ? (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(Stack, null,
                React.createElement(View, { style: {
                        backgroundColor: '#F1F3F5',
                        paddingHorizontal: 12,
                        paddingVertical: 4,
                    } },
                    React.createElement(Typography, { label: warning, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }))))) : (React.createElement(React.Fragment, null))));
};
export default memo(Repayment);
export { Repayment };
